import { Controller } from "@hotwired/stimulus";

// Client-side preview of the chosen thank-you-card design: a thumbnail for
// images, a filename tile for PDFs (they are printed as uploaded, never
// rendered). A newly chosen file supersedes a design kept from a 422.
export default class extends Controller {
  static targets = ["input", "preview", "previous"];

  show() {
    const file = this.inputTarget.files[0];
    if (!file) return;

    this.previousTargets.forEach((element) => element.remove());
    this.previewTarget.replaceChildren(this.render(file));
  }

  render(file) {
    if (file.type.startsWith("image/")) {
      const image = document.createElement("img");
      image.src = URL.createObjectURL(file);
      image.alt = file.name;
      image.className = "max-h-72 rounded-lg border border-gray-200";
      return image;
    }

    const tile = document.createElement("div");
    tile.className = "flex items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm font-medium text-gray-900";
    tile.textContent = file.name;
    return tile;
  }
}
